/**
 * Canonical site-wide defaults for page metadata.
 *
 * SINGLE SOURCE OF TRUTH — import from here, do not duplicate literals.
 *
 * Consumers:
 *   - src/hooks/use-document-title.ts  (client-side meta updates)
 *   - plugins/og-meta.ts               (dev/preview server crawler middleware)
 *   - index.html                       (static SSR fallback — hand-maintained,
 *                                       kept in sync with SITE_DEFAULT_DESCRIPTION)
 *   - src/pages/home.tsx               (hero copy — DIRECTORY_HERO / OPPORTUNITIES_HERO)
 *   - src/pages/og-template.tsx        (OG card variants)
 */
export const SITE_NAME = "The Carry Network";

export const SITE_DEFAULT_DESCRIPTION =
  "The Carry Network is a verified directory of Riot Games alumni: a place to find people you worked with, share openings and leads, and help each other figure out what's next.";

export const DIRECTORY_HERO = {
  headlinePlain: "Hire Verified",
  headlineAccent: "Riot Alumni.",
  subhead: "Every member of this directory is a hand-verified Riot Games alum. Browse by discipline, see who's open to work right now, and reach out directly.",
} as const;

export const OPPORTUNITIES_HERO = {
  headlinePlain: "Find Your People.",
  headlineAccent: "Find What's Next.",
  subhead: "The Carry Network is a verified directory of Riot Games alumni: reconnect with people you worked with, share openings and leads, and help each other forward.",
} as const;

// Versioned OG image filenames — update the version suffix when recapturing.
// keep in sync with the const block in artifacts/api-server/src/routes/ssr.ts
export const OG_DIRECTORY_IMAGE = "/opengraph-directory.v1.jpg";
export const OG_INVITE_IMAGE    = "/opengraph-invite.v1.jpg";
